export const ZU = {
    translations: {
        notifications: 'Izaziso',
        markAllAsRead: 'Maka konke njengokufundiwe',
        poweredBy: 'Inikezwe amandla yi',
        settings: 'Izilungiselelo',
        noNewNotification: 'Akukho okusha ongakubona lapha okwamanje',
    },
    lang: 'zu',
};
//# sourceMappingURL=zu.js.map